import { TableTypeEnum } from "@selector/shared/openapi";
import type { ColDef, ColGroupDef } from "ag-grid-enterprise";

export const TableTypeNamesMap: Partial<Record<TableTypeEnum, string>> = {
  [TableTypeEnum.PANGENOME]: "Pangenome",
  [TableTypeEnum.ORGANISM]: "Organisms",
  [TableTypeEnum.GENE]: "Genes",
  [TableTypeEnum.PROTEIN_LOCATION]: "Proteins",
  [TableTypeEnum.TRANSCRIPT_LOCATION]: "Transcripts",
  [TableTypeEnum.NU_FEATURE]: "DNA Feature",
};

export enum TableRestriction {
  GENOME = "GENOME",
  CONTIG = "CONTIG",
  REGION = "REGION",
  SELECTION = "SELECTION",
}

export const MAX_MT_ROW_COUNT = 400_000; // 400_000 is the MT limitation

export const DEFAULT_MIN_COLUMN_WIDTH = 110;

export const DEFAULT_COLUMN_DEFINITION: ColDef = {
  minWidth: DEFAULT_MIN_COLUMN_WIDTH,
  resizable: true,
  autoHeaderHeight: true,
  suppressSpanHeaderHeight: true,
};

export const DEFAULT_COLUMN_GROUP_DEFINITION: Partial<ColGroupDef> = {
  suppressHeaderContextMenu: true,
};

export const SELECTION_COLUMN_DEFINITION: ColDef = {
  contextMenuItems: [],
  pinned: "left",
  lockPinned: true,
  suppressMovable: true,
  lockPosition: "left",
  resizable: false,
  width: 32,
  maxWidth: 32,
  headerStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
  cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
};
